export default __webpack_public_path__ + "static/media/wall-2.392362fa.svg";